import api from '../api'
import router from '../router';
const state = {
    loading: false,
    isAnonymous: localStorage.getItem('login') ? (JSON.parse(localStorage.getItem('login'))).isAnonymous : true,
    ageLimit: [],
    leaderboard: localStorage.getItem('leaderboard') ? JSON.parse(localStorage.getItem('leaderboard')) : [],
    successLogin: false,
    apiError : null
};

const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },
    setLoginData(state, loginData) {
        state.successLogin = true;
        localStorage.setItem('login', loginData);
    },
    setAgeLimit(state, ageLimit) {
        state.ageLimit = ageLimit;
    },
    setLeaderboardData(state, leaderboard) {
        state.leaderboard = leaderboard;
    },
    setError(state, apiError){
        state.apiError = apiError;
    }
};

const getters = {
    getLeaderBoard(state) {
        let rank = 0;
            return state.leaderboard?.leaderboard?.map(leaderboard => {
                rank = leaderboard?.rank ?? rank + 1;
                return {
                    rank: leaderboard?.rank ?? rank,
                    // name: leaderboard?.name ?? (localStorage.getItem("name") ? localStorage.getItem("name") : "-"),
                    name: leaderboard?.name ?? "-",
                    repCount: leaderboard?.repCount ?? 0,
                    movementQuality: leaderboard?.moveQuality ?? 0,
                    email: leaderboard?.email ?? (localStorage.getItem("user-email") ? localStorage.getItem("user-email") : "-"),
                }
            })
    }
};

const actions = {
    async loginProcess({ commit }, credentials) {
        commit('setLoading', true);
        try {
            const data = await api.login(credentials);
            if (data) {
                commit('setLoginData', JSON.stringify({ isAnonymous: false,  ...data }))
            }
        }
        catch (e) {
            let apiError = await e.text();
            if (e.status == 401) {
                apiError = "Invalid username or password.";
            }
            commit('setError', apiError)
        }
        finally {
            commit('setLoading', false);
        };
    },
    async getAgeLimit({ commit, dispatch }) {
        commit('setLoading', true);
        try {
            const data = await api.getAgeLimit();
            if (data) {
                commit('setAgeLimit', data)
            }
        }
        catch (e) {
            try {
                if(e?.status == 401){
                    await dispatch("getRefreshToken");
                    const data = await api.getAgeLimit();
                    if (data) {
                        commit('setAgeLimit', data)
                    }
                }
            } catch {
                Promise.reject(e);
            }
        }
        finally {
            commit('setLoading', false);
        };
    },
    async uploadDetailsAndGetLeaderBoard({ commit, dispatch }, userDetails) {
        commit('setLoading', true);
        try {
            const data = await api.getLeaderBoard(userDetails);
            if (data) {
                localStorage.setItem('leaderboard', JSON.stringify(data));
                commit('setLeaderboardData', data)
            }
        }
        catch (e) {
            try {
                if(e?.status == 401){
                    await dispatch("getRefreshToken");
                    const data = await api.getLeaderBoard(userDetails);
                    if (data) {
                        localStorage.setItem('leaderboard', JSON.stringify(data));
                        commit('setLeaderboardData', data)
                    }
                }
            } catch {
                Promise.reject(e);
            }
        }
        finally {
            commit('setLoading', false);
        };
    },
    async getRefreshToken({commit}){
        try{
            let data = await api.refreshToken();
            if(data){
                commit('setLoginData', JSON.stringify({ isAnonymous: false,  ...data }))
            }
        }
        catch(e){
            localStorage.removeItem('login');
            router.push({name: 'sign-in'})
        }
    },
    async getLeaderBoardV2({dispatch}){
        try {
            const data = await api.getLeaderBoardV2();
            return data;
        }
        catch (e) {
            try {
                if(e?.status == 401){
                    await dispatch("getRefreshToken");
                    const data = await api.getLeaderBoardV2();
                    if (data) {
                        return data;
                    }
                }
            } catch {
                Promise.reject(e);
            }
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
}
